import {createRoot} from 'react-dom/client'
import {App} from './App'
import {preloadEngine} from './engine/engine'
import './styles.css'

// Decide the engine and warm it while the user reads the landing page. Devices
// that will run WebXR never fetch the 8th Wall binary (6.3 MB); devices that
// need it start fetching now, as the old index.html <script> tag did.
preloadEngine()

// No StrictMode: its dev double-mount would boot the camera engine twice.
createRoot(document.getElementById('root')!).render(<App />)
